import React, { useState, Fragment, useEffect, useRef } from "react";
import { Table, Row, Col, Card, CardBody, Input, Label } from "reactstrap";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import axios from "axios";
import usePersistStoreData from "../Hooks/usePersistStoreData";
import CommonLoading from "./CommonLoading";
import { useVirtualizer } from '@tanstack/react-virtual';

const TableContainerSearchHoldings = ({
  footer,
  summary,
  columns,
  data,
  theadClass = "",
  tbodyClass = "",
  footer2,
  setSelectedVariance,
  selectedVariance,
  varianceLoading,
  handleApplyClick,
  varianceType,
  globalFilter,
  setGlobalFilter
}) => {
  
  const [summaryData, setSummarydata] = useState(summary);
  
  

  // React-Table setup
  // const table = useReactTable({
  //   columns,
  //   data,
  //   getCoreRowModel: getCoreRowModel(),
  //   getSortedRowModel: getSortedRowModel(),
  //   getFilteredRowModel: getFilteredRowModel(),
  //   globalFilterFn: (row, columnId, filterValue) => {
  //     return String(row.getValue(columnId))
  //       .toLowerCase()
  //       .includes(filterValue.toLowerCase());
  //   },
  // });
  const [sorting, setSorting] = useState([]); // Added sorting state

  // React-Table setup
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      globalFilter,
      sorting, // Use sorting state
    },
    onGlobalFilterChange: setGlobalFilter,
    onSortingChange: setSorting, // Update sorting state
  });

  const {
    getHeaderGroups,
    getRowModel,
    getCanPreviousPage,
    getCanNextPage,
    getPageOptions,
    setPageIndex,
    nextPage,
    previousPage,
    setPageSize,
    getState
  } = table;

  // console.log("table data",getRowModel().rows)

  const isNumeric = (value) => {
    if (typeof value === "number") return true;
    if (typeof value === "string") {
      // Remove commas before testing
      return !isNaN(Number(value.replace(/,/g, "")));
    }
    return false;
  };

  const { userData } = usePersistStoreData();
  
  const token = userData?.token;

  const tableContainerRef = useRef(null);
  
  const rows = table.getRowModel().rows;

  // Virtual row configuration
  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    getScrollElement: () => tableContainerRef.current,
    estimateSize: () => 45, // Estimated row height in pixels
    overscan: 10, // Number of items to render outside visible area
  });

  const virtualRows = rowVirtualizer.getVirtualItems();
  const totalSize = rowVirtualizer.getTotalSize();

  const paddingTop = virtualRows.length > 0 ? virtualRows[0].start : 0;
  const paddingBottom = virtualRows.length > 0 
    ? totalSize - virtualRows[virtualRows.length - 1].end 
    : 0;

 

  useEffect(()=>{
    const totals = getRowModel().rows.reduce(
      (acc, item) => {
        acc.total_closing_price += +item?.original.closing_price || 0;
        acc.total_net_value += +item?.original.net_value || 0;
        acc.total_current_value += +item?.original.current_value || 0;

        acc.total_pnl += +item?.original.pnl || 0;
        return acc;
      },
      { total_closing_price: 0, total_net_value: 0, total_current_value: 0,  total_pnl: 0 }
    );
    // console.log("total",totals)
    // console.log("data", getRowModel().rows)
    setSummarydata(totals)
  },[getRowModel,globalFilter])

  

  return (
    <Fragment>
      {/* Search Input */}
      <Row className="">
        {/* <Col xl="4" xxl="3" lg="7" md="12" xs="12" className=" mb-2 mb-xxl-0">
        <div class="search-box d-inline-block col-12">
          <input
          id="search-bar-0"
            type="text"
            style={{backgroundColor:'#F1F4F7',border:'1px solid transparent'}}
            className="form-control border-0 search"
            placeholder="Search by Scrip Name"
            value={globalFilter}
            onChange={(e) => {
              
              setGlobalFilter(e.target.value);

             
            }}
          />
          
           
              <i class="bx bx-search-alt search-icon"></i>
              </div>
        </Col> */}
        {/* {varianceType && (
           <>
              <Col xl="5" xxl="3" lg="7" md="9" sm="12" className=" mb-2 mb-xxl-0">
        <div className="d-flex justify-content-center">
            <Label htmlFor="type" className="form-label d-flex align-items-center  m-0 me-2 text-dark fs-14 fw-medium">
              Select Report Type:
            </Label>
          <Input
            type="select"
            id="type"
            name="type"
            className="form-control"
            style={{
              backgroundColor: "#F1F4F7",
              border: "1px solid transparent",
              height: "38px",
              width: "calc(100% - 160px)"
            }}
            
            value={selectedVariance}
            onChange={(e) => setSelectedVariance(e.target.value)}
          >
            <option value="With">With Variance</option>
            <option value="Without">Without Variance</option>
            
            
          </Input>
          </div>
        </Col>
        <Col xl="2" xxl="1" lg="2" md="3" sm="12">
          <button
            className="btn btn-primary w-100"
            style={{ height: "38px" }}
            onClick={handleApplyClick}
          >
            Apply
          </button>
        </Col>
           </>
        )} */}
     
      </Row>

      {/* Table Container */}
     
      <div 
      ref={tableContainerRef}
      style={{
        maxHeight: '70vh', 
        overflow: 'auto',
        position: 'relative'
      }}
      className="table-responsive table-container"
    >
      <table className="table table-hover align-middle table-nowrap table-bordered">
        <thead 
          className={`bg-gl-primary sticky-header ${theadClass}`}
          style={{
            position: 'sticky',
            top: -1,
            zIndex: 2,
            background: 'inherit'
          }}
        >
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                const isSorted = header.column.getIsSorted();
                return (
                  <th
                    key={header.id}
                    style={{
                      textAlign: header.column.columnDef.headerTextAlign,
                      cursor: "pointer",
                      whiteSpace: "normal", 
                      padding: "0.3rem",
                      paddingLeft: "0.4rem"
                    }}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      {flexRender(
                        header.column.columnDef.Header,
                        header.getContext()
                      )}
                      {isSorted === "asc" ? (
                        <i className="ms-2 bx bx-caret-up"></i>
                      ) : isSorted === "desc" ? (
                        <i className="ms-2 bx bx-caret-down"></i>
                      ) : (
                        <i className="ms-2 bx bxs-sort-alt"></i>
                      )}
                    </div>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>

        <tbody className={tbodyClass}>
          {data?.length > 0 ? (
            rows.length > 0 ? (
              <>
                {paddingTop > 0 && (
                  <tr>
                    <td colSpan={columns?.length} style={{ height: `${paddingTop}px` }} />
                  </tr>
                )}
                {virtualRows.map((virtualRow) => {
                  const row = rows[virtualRow.index];
                  return (
                    <tr key={row.id}>
                      {row.getVisibleCells().map((cell) => {
                        const rawValue = cell.getValue();

                        let renderedContent = flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        );
          
                        if (cell.column.id !== "pnl" && isNumeric(rawValue)) {
                          const numValue = Number(String(rawValue).replace(/,/g, ""));
                          renderedContent = numValue.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          });
                        } else if (!React.isValidElement(renderedContent) && isNumeric(rawValue)) {
                          const numValue = Number(String(rawValue).replace(/,/g, ""));
                          renderedContent = numValue.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          });
                        }
          
                        return (
                          <td
                            key={cell.id}
                            className="fs-p-bg fw-medium"
                            style={{
                              textAlign: cell.column.columnDef.bodyTextAlign,
                              width: cell.column.columnDef.size,
                              ...cell.column.columnDef.meta?.style,
                              whiteSpace: "normal",
                              padding: "0.3rem",
                              paddingLeft: "0.4rem"
                            }}
                          >
                            {renderedContent}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
                {paddingBottom > 0 && (
                  <tr>
                    <td colSpan={columns?.length} style={{ height: `${paddingBottom}px` }} />
                  </tr>
                )}
              </>
            ) : (
              <tr>
                <td
                  colSpan={columns?.length}
                  className="p-1"
                  style={{ textAlign: "center" }}
                >
                  <div className="card m-0 text-muted">
                    <div className="card-body">No Record Found</div>
                  </div>
                </td>
              </tr>
            )
          ) : (
            <tr>
              <td
                colSpan={columns?.length}
                className="p-1"
                style={{ textAlign: "center" }}
              >
                <div className="card m-0 text-muted">
                  <div className="card-body">No Record Found</div>
                </div>
              </td>
            </tr>
          )}
        </tbody>

        {footer && (
          <tfoot 
            className="table-footer sticky-footer"
            style={{
              position: 'sticky',
              bottom: -1,
              zIndex: 2,
              background: 'inherit'
            }}
          >
            <tr className="bg-gl-success">
              <th colSpan={5} style={{ textAlign: "end" }}>
                Total 
              </th>
              <th style={{ textAlign: "end" }}>
                {Number(summary?.total_short ?? 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </th>
              <th style={{ textAlign: "end" }}>
                {Number(summary?.total_long ?? 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </th>
              <th style={{ textAlign: "end" }}>
                {Number(summary?.total_jobbing ?? 0).toLocaleString(
                  "en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )}
              </th>
            </tr>
          </tfoot>
        )}

        {footer2 && (
          <tfoot 
            className="table-footer sticky-footer"
            style={{
              position: 'sticky',
              bottom: 0,
              zIndex: 2,
              background: 'inherit'
            }}
          >
            <tr className="bg-gl-success">
              <th style={{ textAlign: "start" }}>
                TOTAL
              </th>
              <th 
                colSpan={
                  footer2 === "withoutMtf"
                    ? 5
                    : footer2 === "includeMtf"
                    ? 7
                    : footer2 === "onlyMtf"
                    ? 4
                    : 1
                } 
                style={{ textAlign: "end" }}
              >
              </th>
              <th style={{ textAlign: "end" }}>
                {Number(summaryData?.total_closing_price ?? 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </th>
              <th style={{ textAlign: "end" }}>
                {Number(summaryData?.total_net_value ?? 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </th>
              <th style={{ textAlign: "end" }}>
                {""}
              </th>
              <th style={{ textAlign: "end" }}>
                {Number(summaryData?.total_current_value ?? 0).toLocaleString(
                  "en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )}
              </th>
              <th style={{ textAlign: "end" }}>
                {Number(summaryData?.total_pnl ?? 0).toLocaleString(
                  "en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )}
              </th>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
    </Fragment>
  );
};

export default TableContainerSearchHoldings;
